<template>
    <div id="videos" class="container">
      <div class="popup" v-if="openedPopup">
        <div class="popup-overlay" @click="openedPopup = !openedPopup"></div>
        <div class="popup-content">
          <i class="fa fa-times close" aria-hidden="true" @click="openedPopup = !openedPopup"></i>
          <div class="title">{{popupVideoTitle}}</div>
          <iframe 
          id="ytplayer" 
          type="text/html" 
          width="640" 
          height="360"
          :src="'https://www.youtube.com/embed/'+popupVideo"
          frameborder="0"
          allowfullscreen="allowfullscreen"
          mozallowfullscreen="mozallowfullscreen" 
          msallowfullscreen="msallowfullscreen" 
          oallowfullscreen="oallowfullscreen" 
          webkitallowfullscreen="webkitallowfullscreen">
          </iframe>
        </div>
      </div>
      <div class="section-title">طق حنك</div>
      <!-- <v-select class="rtl" v-model="selected" :options="videoCategories"></v-select> -->
      <!-- <span class="checkbox-filters" v-for="category in videoCategories" :key="category.id">
        <input type="checkbox" :value="category.label" v-model="test">
        <label>{{category.value}}</label>
      </span> -->
      <checkbox class="checkbox-filters" v-for="category in videoCategories" :key="category.id" :value="category.label" v-model="test">
        {{category.value}}<a href="#"></a>
      </checkbox>
      <label>{{selected}}</label>
      <ul>
        <li v-for="(video,index) in filteredVideos" v-if="index <= nVideos" :key="video.id">
          <div @click="openPopup(video)" class="thumbnail" :style="'background-image:url('+videoThumbnail(video)+')'"></div>
          <div class='info'>
            <div class="title">{{video.videoName}}</div>
            <div class="date">{{video.videoDate}}</div>
            <div class="category">{{video.category}}</div>
          </div>
        </li>
      </ul>
      <div class="load-more" v-if="loadMoreCheck" @click="loadMore">المزيد</div>
    </div>
</template>

<script>
export default {
  data () {
      return {
        videos: '',
        openedPopup: false,
        popupVideoLink: '',
        popupVideoTitle: '',
        nVideos: 8,
        videoCategories:[
          {
            value:'لسّه في',
            label:'1'
          },
          {
            value:'تكنولوجيا',
            label:'2'
          },
          {
            value:'جوائز',
            label:'4'
          },
          {
            value:'لقاءات ومحاضرات',
            label:'3'
          }
        ],
        selected:'',
        loadMoreCheck:true,
        videosnnn:'',
        test:[],
        windowWidth:''
      }
  },
  computed: {
    filteredVideos: function () {
      var _this = this;
      var retVal = [];
      if(_this.test.length === 0){
        for (var i = 0; i < _this.videos.length; i++) {
          retVal.push(_this.videos[i])
        }
      }else{
        for (var i = 0; i < _this.videos.length; i++) {
          _this.test.forEach(element => {
            if(_this.videos[i].category_id === element){
              retVal.push(_this.videos[i])
            }
          }); 
        }
      }
      return retVal;
    },
    getWindowWidth() {
        this.windowWidth = document.documentElement.clientWidth;
    },
    getnVideos(){
      if(this.windowWidth < 767){
        this.nVideos = 5
      } else{
        this.nVideos = 8
      }
    }
  },
  methods: {
    openPopup(video){
      this.popupVideo = video.videoLink
      this.popupVideoTitle = video.videoName
      this.openedPopup = true
    },
    loadMore(){
      this.nVideos = this.nVideos + 3
      if (this.videos.length <= this.nVideos ){
        this.loadMoreCheck = false;
      }
    },
    videoThumbnail(video){
      if (video.videoThumbnail === ''){
        return 'https://i.ytimg.com/vi/'+video.videoLink+'/hqdefault.jpg'
      } else{
        return 'https://cms.zaidounk.com/'+video.videoThumbnail
      }
    }
  },
  created () {
    this.$http.get('https://cms.zaidounk.com/api/videos')
    .then(result => {
      return result.json()
    })
    .then(data => {
      this.videos = data
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/components/sections/Videos.vue